import { get } from 'lodash';

const getCollatedAttachments = (state) => {
    const id = get(state, `factoringClient.id`, '');
    return get(state, `factoringClient.collatedFiles.${id}`, {});
};

export default getCollatedAttachments;
